import { render } from "./TradingTrialsStats.vue?vue&type=template&id=125a9546"
import script from "./TradingTrialsStats.vue?vue&type=script&lang=js"
export * from "./TradingTrialsStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__